import Box from '@mui/material/Box';

import { NotificationsCard } from './notifications-card';

const Notification = (): JSX.Element => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1120,
        mx: 'auto',
        px: { xs: 2, md: 4 },
        py: 3,
        boxSizing: 'border-box',
      }}
    >
      <NotificationsCard />
    </Box>
  );
};

export default Notification;
